<template>
  <div class="fair-navigation">
    <bos-loader v-if="isLoading" relative inline />

    <template v-else>
      <ul class="navigation-list">
        <router-link
          v-for="fair in fairnavigation"
          :key="fair.id"
          :to="{ name: $route.name, params: { fair: fair.idCode } }"
          tag="li"
        >
          <a>{{ fair.displayName }}</a>
        </router-link>
      </ul>
    </template>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService'
import BosLoader from '@/components/BosLoader'
import { getLocalizationInExcludes, localize } from '@/assets/js/helper'

export default {
  name: 'fairnavigation',
  props: {
    series: {
      type: String,
      default: null
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['fair/isLoading']
    },
    logo() {
      const data = this.fairnavigation.find(
        fair => fair.idCode === this.$route.params.fair
      ).logo
      if (data == null) {
        return data
      }
      var str = ''
      for (var i = 0; i < data.length; i++) {
        str += String.fromCharCode(data[i])
      }
      return data
    },
    fairs() {
      return this.$store.getters['fair/getWithBooths']
    },
    language() {
      let loose = this.$i18n.locale.substr(0, 2)
      return loose.charAt(0).toUpperCase() + loose.slice(1)
    },
    fairnavigation() {
      let fairNavArr = this.fairs.filter(fair => {
        return (
          fair.rubin[0].reiheId == this.series &&
          new Date(fair.publish.end) <= new Date()
        )
      })

      fairNavArr.sort((fair1, fair2) => {
        const endDate1 = new Date(fair1.duration.end)
        const endDate2 = new Date(fair2.duration.end)
        if (endDate1 > endDate2) {
          return -1
        } else if (endDate1 < endDate2) {
          return 1
        }
        return 0
      })

      let inAndExcludes = getLocalizationInExcludes(this.$i18n.locale)

      return localize(fairNavArr, inAndExcludes.include, inAndExcludes.exclude)
    }
  },
  methods: {
    getFairs() {
      if (!this.isLoading || this.fairs.length === 0) {
        this.$store.dispatch('fair/getWithBooths')
      }
    }
  },
  created() {
    this.getFairs()
  },
  components: {
    BosLoader
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$fairnavi-margin: 0 0 2em !default;

$fairnavi-loader-margin: 1em auto !default;
$fairnavi-loader-size: 3em !default;

$fairnavi-seperator: 1px solid $brand-gray !default;

$fairnavi-state-outerwidth: 30px !default;
$fairnavi-state-bg: $brand-blue !default;
$fairnavi-state-width: 0.75rem !default;
$fairnavi-state-height: 0.25rem !default;

$fairnavi-link-notification-outerwidth: 30px !default;
$fairnavi-link-notification-size: 0.6em !default;
$fairnavi-link-notification-bg: $brand-red !default;
$fairnavi-link-padding: 12px $fairnavi-link-notification-outerwidth 12px 0 !default;
$fairnavi-link-font-weight: $font-weight-bold !default;
$fairnavi-link-textdecoration: none !default;
$fairnavi-link-color: inherit !default;
$fairnavi-link-active-color: $brand-primary !default;

$fairnavi-sublink-padding: 10px 15px 10px 0 !default;
$fairnavi-sublink-font-size: $fairnavi-link-font-size !default;
$fairnavi-sublink-font-weight: $font-weight-normal !default;
$fairnavi-sublink-color: inherit !default;
$fairnavi-sublink-active-color: black !default;

.noclick {
  pointer-events: none;
}

.fair-navigation {
  display: block;
  margin: $fairnavi-margin;
  width: 100%;

  .loader {
    margin: $fairnavi-loader-margin;
    width: 1em;
    font-size: $fairnavi-loader-size;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      > a {
        display: block;
        position: relative;
        padding: $fairnavi-link-padding;
        font-size: $fairnavi-link-font-size;
        font-weight: $fairnavi-link-font-weight;
        color: $fairnavi-link-color;
        text-decoration: $fairnavi-link-textdecoration;
      }

      &.has-notifications {
        > a {
          &:after {
            display: block;
          }
        }
      }

      &.router-link-exact-active {
        > a {
          color: $fairnavi-link-active-color;
        }
      }

      ul {
        li {
          > a {
            padding: $fairnavi-sublink-padding;
            font-size: $fairnavi-sublink-font-size;
            font-weight: $fairnavi-sublink-font-weight;
            color: $fairnavi-sublink-color;

            &:after {
              margin: auto
                calc(
                  #{$fairnavi-link-notification-outerwidth * 0.5} - #{$fairnavi-link-notification-size *
                    0.25}
                );
              width: $fairnavi-link-notification-size * 0.5;
              height: $fairnavi-link-notification-size * 0.5;
            }
          }

          &.is-new-route {
            > a {
              font-size: $fairnavi-link-font-size;
              color: $fairnavi-link-color;
            }
          }

          &.router-link-active {
            > a {
              pointer-events: none;
              color: $fairnavi-sublink-active-color;
              font-weight: $fairnavi-link-font-weight;
            }
          }
        }
      }
    }
  }

  .navigation-list {
    border-top: $fairnavi-seperator;

    > li {
      position: relative;
      //      padding-left: $fairnavi-state-outerwidth;
      border-bottom: $fairnavi-seperator;

      a {
        padding-left: $fairnavi-state-outerwidth + 4px;

        &:hover {
          background-color: $brand-primary;
          color: black;
        }
      }

      &.router-link-active {
        > a {
          &:after {
            background-color: transparent;
          }
        }
      }

      > a {
        font-size: $fairnavi-fair-link-font-size;
        &:after {
          display: none;
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          margin-bottom: 0;
          margin-right: 0;
          background-image: url('~@/assets/images/icons/chevron_bold_right_primary_new.svg');
          background-size: 32px 30px;
          background-repeat: no-repeat;
          background-position: 10px 10px;
          width: 40px;
          height: 40px;

        }
        &:hover {
          &:after {
            background-image: url('~@/assets/images/icons/chevron_bold_down_black_new.svg');
          }
        }

        &.open {
          &:after{
            background-image: url('~@/assets/images/icons/chevron_bold_down_primary_new.svg');
          }
          &:hover {
            &:after {
              background-image: url('~@/assets/images/icons/chevron_bold_right_black_new.svg');
            }
          }
        }

      }

      > ul {
        display: none;
      }

      &.router-link-exact-active {
        &:after {
          display: none;
        }

        > ul {
          display: block;
        }
      }
    }
  }
}
</style>
